import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/image/psychological_renbao_02.jpg'
import _imports_1 from '../../assets/image/psychological_renbao_03.jpg'
import _imports_2 from '../../assets/image/psychological_renbao_04.jpg'
import _imports_3 from '../../assets/image/psychological_renbao_05.jpg'

const _withId = /*#__PURE__*/_withScopeId("data-v-951b59ae")

_pushScopeId("data-v-951b59ae")
const _hoisted_1 = { class: "PsychologicalActivity" }
const _hoisted_2 = /*#__PURE__*/_createVNode("img", {
  class: "back-img",
  src: _imports_0
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("img", {
  class: "back-img",
  src: _imports_1
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("img", {
  class: "back-img",
  src: _imports_2
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("img", {
  class: "back-img",
  src: _imports_3
}, null, -1)
const _hoisted_6 = { class: "btn-content" }
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "text" }, " 立即拨打 ", -1)
const _hoisted_8 = { style: {"background-color":"white","border-radius":"5px","margin-bottom":"5px","padding":"10px"} }
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" 将呼叫该虚拟号码 ")
const _hoisted_10 = { style: {"color":"black","font-size":"24px","margin-top":"5px"} }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_van_icon = _resolveComponent("van-icon")
  const _component_van_action_sheet = _resolveComponent("van-action-sheet")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _hoisted_4,
    _hoisted_5,
    _createVNode("div", _hoisted_6, [
      _createVNode("a", {
        class: "btn-item",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.gotoConsult && _ctx.gotoConsult(...args)))
      }, [
        _hoisted_7
      ])
    ]),
    _createVNode(_component_van_action_sheet, {
      show: _ctx.state.show,
      "onUpdate:show": _cache[3] || (_cache[3] = ($event: any) => (_ctx.state.show = $event)),
      style: {"background":"unset"},
      class: "actions",
      round: false,
      "close-on-click-action": ""
    }, {
      default: _withId(() => [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.actions, (item, index) => {
          return (_openBlock(), _createBlock("div", {
            style: {"background-color":"white","text-align":"center","font-size":"16px","margin":"10px","padding":"20px 10px","border-radius":"5px"},
            key: index
          }, [
            _createVNode(_component_van_icon, {
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.state.show = false)),
              style: {"position":"absolute","right":"10px","top":"10px","padding":"10px"},
              name: "cross"
            }),
            _createVNode("div", _hoisted_8, [
              _hoisted_9,
              _createVNode("div", _hoisted_10, _toDisplayString(item.tel.replace(/^(.{3})(.*)(.{4})$/, '$1 $2 $3')), 1)
            ]),
            _createVNode("div", {
              onClick: ($event: any) => (_ctx.toTel(item.tel)),
              style: {"background-color":"#eb5e82","color":"white","border-radius":"5px","margin-bottom":"5px","padding":"10px"}
            }, " 立即呼叫(加密) ", 8, ["onClick"])
          ]))
        }), 128))
      ]),
      _: 1
    }, 8, ["show"])
  ]))
})